import { render, staticRenderFns } from "./VPI.vue?vue&type=template&id=209bbb46&scoped=true&"
import script from "./VPI.vue?vue&type=script&lang=js&"
export * from "./VPI.vue?vue&type=script&lang=js&"
import style0 from "./VPI.vue?vue&type=style&index=0&id=209bbb46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209bbb46",
  null
  
)

export default component.exports